import { toast } from "react-toastify";
export const { error, success, info, warning }: any = toast;

const handleToast = (content: string, type?: any) => {
  toast.dismiss();
  type = type ? type : error;
  type(content)
}

export default handleToast;